import { makeAutoObservable } from 'mobx';
import * as utils from '@intrasync/utils';
import ScheduleGridStoreNamespace from './ScheduleGridStoreNamespace';
import RootStore from '../RootStore';

class ScheduleGridStore {
  rootStore: RootStore;
  namespaces: Record<string, ScheduleGridStoreNamespace> = {};

  constructor(rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
  }

  setupNamespace = (namespaceId?: string): string => {
    const id = namespaceId || utils.uuid();
    this.namespaces[id] = new ScheduleGridStoreNamespace(this.rootStore, id);
    return id;
  };

  clearNamespace = (namespaceId: string): void => {
    console.log('clearNamespace namespaceId', namespaceId);
    delete this.namespaces[namespaceId];
  };

  clearAllNamespaces = (): void => {
    console.log('clearAllNamespaces');
    this.namespaces = {};
  };

  get availableNameSpaces(): string[] {
    return Object.keys(this.namespaces);
  }
}

export default ScheduleGridStore;
